// Used as part of a workaround where Edge windows incorrectly think Office.js is running
// outside of an Office application
// https://office.visualstudio.com/OC/_workitems/edit/2615502
export const localStorageIsSignedInKey = 'StickyNotesAgaveIsSignedIn'
export const msaCommonAuthImplicitCredentials = 'MsaCommonAuthImplicitCredentials'
export const o365CommonAuthAccessToken = 'O365CommonAuthAccessToken'
